module.exports = __webpack_public_path__ + "img/Polypharmacy.20350f25.jpg";